// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CapsuleController from "./capsule_controller"
application.register("capsule", CapsuleController)

import CourseController from "./course_controller"
application.register("course", CourseController)

import CronometroController from "./cronometro_controller"
application.register("cronometro", CronometroController)

import HomeController from "./home_controller"
application.register("home", HomeController)

import LessonController from "./lesson_controller"
application.register("lesson", LessonController)

import LoginController from "./login_controller"
application.register("login", LoginController)

import OrderController from "./order_controller"
application.register("order", OrderController)

import RaviController from "./ravi_controller"
application.register("ravi", RaviController)

import GradesController from "./grades_controller"
application.register("grades", GradesController)

import TablistController from "./tablist_controller"
application.register("tablist", TablistController)

import LessonsVideosController from "./lessons/videos_controller"
application.register("lessons--videos", LessonsVideosController)

import LessonsMaterialsController from "./lessons/materials_controller"
application.register("lessons--materials", LessonsMaterialsController)

import LessonsProgressController from "./lessons/progress_controller"
application.register("lessons--progress", LessonsProgressController)
